export default __webpack_public_path__ + "static/media/LOGO.89a0bdd5.JPG";